import type { CMSPlanCards } from '../schemas';
import { match } from 'ts-pattern';
import { CMSPlanCardMobile } from './cms-plan-card-mobile';
import { CMSPlanCardBroadband } from './cms-plan-card-broadband';
import { cn } from '@/lib/utils';

interface CMSPlanCardsProps {
  planCardsData: CMSPlanCards;
  className?: string;
}

const CMSPlanCardsWrapper = ({
  planCardsData,
  className,
}: CMSPlanCardsProps) => {
  const productType = planCardsData.product_type.key;
  const customerSegment = planCardsData.customer_segment.key;

  return (
    <div className={cn(className)}>
      {match(productType)
        .with('BROADBAND', () => (
          <CMSPlanCardBroadband customerSegment={customerSegment} />
        ))
        .with('MOBILE', () => <CMSPlanCardMobile />)
        .otherwise(() => null)}
    </div>
  );
};

export { CMSPlanCardsWrapper };
